// 404 Not Found Page
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Button } from '../components/ui/button';
import { Home, Search, ArrowLeft, HelpCircle } from 'lucide-react';

const NotFound = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen flex items-center justify-center px-4 ${isDarkMode ? 'bg-slate-900' : 'bg-gray-50'}`}>
      <div className="text-center max-w-lg">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-9xl font-bold bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">
            404
          </div>
          <div className="text-6xl mt-2">🏥</div>
        </div>

        {/* Message */}
        <h1 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          Page introuvable
        </h1>
        <p className={`text-lg mb-8 ${isDarkMode ? 'text-slate-400' : 'text-gray-600'}`}>
          Oups ! Cette page semble avoir pris un jour de congé médical. 
          Elle n'existe pas ou a été déplacée.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700">
              <Home className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <Link to="/professionals">
            <Button variant="outline" className="w-full sm:w-auto">
              <Search className="w-4 h-4 mr-2" />
              Rechercher un médecin
            </Button>
          </Link>
        </div>

        {/* Help Link */}
        <div className="mt-8">
          <Link 
            to="/faq" 
            className={`inline-flex items-center gap-2 text-sm ${isDarkMode ? 'text-slate-500 hover:text-slate-400' : 'text-gray-500 hover:text-gray-700'}`}
          >
            <HelpCircle className="w-4 h-4" />
            Besoin d'aide ?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
